import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import * as ROUTES from '../../../../constants/routes';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import ReactModal from 'react-modal';
import { get } from 'lodash'
import AddMemberModal from './AddMemberModal';
import AddMemberAll from './AddMemberAll';
import { openCompanyMemberModal } from '../../../../store/actions/projectActions';

class AddMemberCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            companyMemberNameForSearch: "",
            showAllCompanyMembersModal: false,
            showAddConfirmModal: false,
            toBeChangedEmployeeMapJson: null,
            changerEmployeeMapJson: null,
        }
    }

    /// README: TO BE SEARCH ENTRY
    handleSearch = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /// README: SEARCH STRING VALIDITY CHECK
    //      (return true if "" and " " is not entered as first character)
    checkValidSearch = () => {
        const { companyMemberNameForSearch } = this.state;
        return (companyMemberNameForSearch === "" || companyMemberNameForSearch.startsWith(" ")) === false;
    }

    /// README: FILTERS THE COMPANY accessMap BY SEARCH STRING
    filterBySearch = (s) => {
        const { companyMemberNameForSearch } = this.state;
        var sname = `${s.name}`;
        return sname.toLowerCase().startsWith(companyMemberNameForSearch.toLowerCase());
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num, changerEmployeeMapJson, toBeChangedEmployeeMapJson) => {
        switch (num) {
            case 0: {
                this.setState({ showAllCompanyMembersModal: true, showAddConfirmModal: false });
                this.props.openCompanyMemberModal();
                break;
            }
            case 1: {
                this.setState({ showAllCompanyMembersModal: false, showAddConfirmModal: true, changerEmployeeMapJson, toBeChangedEmployeeMapJson, });
                this.props.openCompanyMemberModal();
                break;
            }
            default: {
                this.setState({ showAllCompanyMembersModal: false, showAddConfirmModal: false });
                this.props.openCompanyMemberModal();
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showAllCompanyMembersModal: false });
                break;
            }
            case 1: {
                this.setState({ showAddConfirmModal: false });
                break;
            }
            default: {
                this.setState({ showAllCompanyMembersModal: false, showAddConfirmModal: false });
                break;
            }
        }
    }

    render() {
        const { themeColors, alu, userData, companyData, snagDetail, modalStyles, project, modalInfoTextStyle } = this.props;
        const { uid, employeeid } = userData;
        const { isMemberAdded } = project;
        const ueid = uid + employeeid;
        var accessLevel = snagDetail.accessMap ? ueid in snagDetail.accessMap ? snagDetail.accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var employeeMapJson = snagDetail.accessMap ? ueid in snagDetail.accessMap ? snagDetail.accessMap[ueid] : null : null;

        /// create relevant button based on access level
        // var newTagButton = createNewTagAccess[accessLevel] ? (<button className="btn btn-dark btn-sm" onClick={() => { this.handleOpenModal(0) }}>Add a tag</button>) : (<React.Fragment></React.Fragment>);

        return (
            <div className="card p-2" style={{ borderRadius: '15px' }}>
                <div className="card-header bg-white p-0 mx-2">
                    <div className="row">
                        <div className="col-10">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Add company members</p>
                        </div>
                        <div className="col-2">
                            {/* <MDICONS.AddCircleOutlineRounded /> */}
                        </div>
                    </div>
                    <p style={modalInfoTextStyle}>Add more people from the company to this project.</p>
                </div>
                <div className="card-body">
                    <div className="form-group text-left">
                        <input type="text" className="form-control" id="companyMemberNameForSearch" placeholder="Search for a company member" onChange={this.handleSearch} />
                        <div>
                            {companyData ? 'accessMap' in companyData ? Object.keys(companyData.accessMap).length !== 0 ? this.checkValidSearch() ? Object.values(companyData.accessMap).filter(this.filterBySearch).slice(0, 2).map((val, i) => {

                                var mueid = val.uid + val.employeeid;
                                var memberAccessLevel = companyData.accessMap ? mueid in companyData.accessMap ? companyData.accessMap[mueid]['access'] : alu.invalid : alu.invalid;
                                const isAlreadyInProject = [...snagDetail.accessList].indexOf(mueid) > -1;
                                return (
                                    <div key={i}>
                                        <li className="card p-2 m-2" style={{ borderRadius: '10px' }}>
                                            <div className="d-flex" >
                                                <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{val.name}
                                                    <br />
                                                    <p className="badge badge-pill  px-3" style={{ backgroundColor: `${alu.color[memberAccessLevel]}`, color: `${alu.textColor[memberAccessLevel]}`, textAlign: "start", fontSize: "10px", fontStyle: "italic" }}>
                                                        {alu.text[memberAccessLevel]}</p>
                                                </div>
                                                <div className="p-2 flex-fill">
                                                    {isAlreadyInProject ? <React.Fragment /> : <div className="btn btn-outline-dark btn-sm float-right" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(1, employeeMapJson, val) }}>Add to project</div>}
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                )
                            }) : '' : 'No member found' : 'No member found' : ''}
                        </div>
                        <br />
                        <div className="btn btn-dark btn-sm" style={{ borderRadius: '9px' }} onClick={() => { this.handleOpenModal(0) }}>View all</div>
                    </div>

                    {/* ALL COMPANY MEMBERS MODAL */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showAllCompanyMembersModal && !isMemberAdded === true}
                        onRequestClose={() => { this.handleCloseModal(0) }}
                        contentLabel="See all company members"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddMemberAll companyMemberNameForSearch={this.state.companyMemberNameForSearch} />
                    </ReactModal>

                    {/* CONFIRM MODAL */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showAddConfirmModal && !isMemberAdded === true}
                        onRequestClose={() => { this.handleCloseModal(1) }}
                        contentLabel="Add company member to project"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddMemberModal toBeChangedEmployeeMapJson={this.state.toBeChangedEmployeeMapJson} changerEmployeeMapJson={this.state.changerEmployeeMapJson} />
                    </ReactModal>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        alu: state.alu,

        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

        // styles
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openCompanyMemberModal: () => dispatch(openCompanyMemberModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMemberCard)
